export default __webpack_public_path__ + "static/media/consultancy.d0cc7dee.jpg";